<template>
	<div ref="CollectDataPopup" class="dialog-container">
		<div class="dialog scroll" style="transform: translate(0, -400px);">
			<form @submit.stop="doValidation()">
				<div class="home-title">
					<div class="title-left" style="font-size: 20px; width: 100%;">
						<img style="width: 20px; height: 17.32px;" src="@/assets/images/login/title_icon.png" />
						<span>수집데이터 상세정보</span>
						<div style="margin-left: auto; cursor: pointer;">
							<!-- <img style="width: 23px; height: 25px;" src="@/assets/images/login/bell_icon.png" /> -->
							<button class="btn-cancel" type="button" style="font-size: 15px; margin-left: 12px;" @click.stop="doOpen()">전체 데이터 기록</button>
						</div>
					</div>
				</div>
				<div class="center dialog-flex">
					<div>
						<span class="dialog-tag">참여자 정보</span>
						<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
							<colgroup>
								<col width="140px" />
								<col width="440px" />
								<col width="140px" />
								<col width="auto" />
							</colgroup>
							<tbody>
								<tr style="border-top: 1px solid #191C26">
									<th>참여자 번호</th>
									<td>
										{{ collectData.id }}
									</td>
									<th>이름</th>
									<td>
										{{ collectData.name }}
									</td>
								</tr>
								<tr>
									<th>전화번호</th>
									<td>
										{{ collectData.phone }}
									</td>
									<th>분만 예정일</th>
									<td>
									</td>
								</tr>
								<tr>
									<th>응급지원</th>
									<td>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="center dialog-flex">
					<div>
						<div class="dialog-tag">
							데이터 상세
							<template
								v-for="(data, index) in collectData.dataList"
							>
								<button 
									type="button"
									class="btn-cancel btn-collect"
									:class="data.recordType == selectRecordType ? 'data-on' : ''"
									title="Cancel"
									@click.stop="selectRecord(data.recordType)"
									:key="index"
									>
									{{ getRecordType(data.recordType) }}
								</button>
							</template>
						</div>

						<!-- 데이터 상세 -->
						<!-- 혈압 -->
						<template
							v-for="(data, index) in collectData.dataList"
						>
							<table 
								v-if="selectRecordType == data.recordType" 
								class="tb-crud-horizon popup-table" 
								style="margin-top: 12.5px;"
								:key="index + 'table'"
							>
								<colgroup>
									<col width="140px" />
									<col width="440px" />
									<col width="140px" />
									<col width="auto" />
								</colgroup>
								<tbody>
									<tr style="border-top: 1px solid #191C26">
										<th v-if="data.recordType == 'WEIGHT'">체중</th>
										<th v-if="data.recordType == 'BLOOD_PRESSURE'">수축기</th>
										<th v-if="data.recordType == 'BLOOD_GLUCOSE'">혈당</th>
										<th v-if="data.recordType == 'HEART_RATE'">심박수</th>
										<th v-if="data.recordType == 'STEP_COUNT'">걸음수</th>
										<th v-if="data.recordType == 'CALORIE'">칼로리</th>
										<th v-if="data.recordType == 'PROTEINURIA'">업로드 된<br>요 시험지</th>
										<th v-if="data.recordType == 'OXYGEN_SATURATION'">산소포화도</th>
										<th v-if="data.recordType == 'STRESS'">스트레스</th>
										<th v-if="data.recordType == 'SLEEP_TIME'">수면시간</th>
										<td v-if="data.recordType == 'PROTEINURIA'">
											<img :src="'data:image/gif;base64,' + data.raw " class="proteinuria_img">
										</td>
										<th v-if="data.recordType == 'PROTEINURIA'">요 시험지 색상</th>
										<td>
											<span v-if="data.recordType != 'PROTEINURIA'">
												{{ data.recordType == 'SLEEP_TIME' ? getSleepTime(data.value) : data.value }}
											</span>
											<div
												v-if="data.recordType == 'PROTEINURIA'"
												class="proteinuria_div"
											>
												<div style="display: flex; column-gap: 15px; align-items: center;">
													<div class="proteinuria_color" :class="data.value == '1' ? 'proteinuria_set' : ''" style="background-color: #fefa9b"></div>
													<div class="proteinuria_color" :class="data.value == '2' ? 'proteinuria_set' : ''" style="background-color: #efeb8f"></div>
													<div class="proteinuria_color" :class="data.value == '3' ? 'proteinuria_set' : ''" style="background-color: #c4d855"></div>
													<div class="proteinuria_color" :class="data.value == '4' ? 'proteinuria_set' : ''" style="background-color: #bbd2a0"></div>
													<div class="proteinuria_color" :class="data.value == '5' ? 'proteinuria_set' : ''" style="background-color: #9ab39b"></div>
													<div class="proteinuria_color" :class="data.value == '6' ? 'proteinuria_set' : ''" style="background-color: #8aaf9a"></div>
												</div>
												<span v-if="data.value == 1">0 mg/L</span>
												<span v-if="data.value == 2">15-30 mg/L</span>
												<span v-if="data.value == 3">30 mg/L</span>
												<span v-if="data.value == 4">100 mg/L</span>
												<span v-if="data.value == 5">300 mg/L</span>
												<span v-if="data.value == 6">1000 mg/L 이상</span>
											</div>
										</td>
										<th v-if="data.recordType == 'BLOOD_PRESSURE'">이완기</th>
										<td v-if="data.recordType == 'BLOOD_PRESSURE'">
											{{ data.subValue }}
										</td>
									</tr>
									<tr>
										<th>상태</th>
										<td v-if="data.recordType != 'PROTEINURIA'">
											<div class="status" :class="statusColor(data.status)">{{getStatusType(data.status)}}</div>
										</td>
										<td v-if="data.recordType == 'PROTEINURIA'">
											<div class="status" :class="statusColor(data.status) == 'green' ? statusColor(data.status) : 'gray'" style="float: left; cursor: pointer;" @click.stop="changeStatus(data, 'NORMAL')">정상</div>
											<div class="status" :class="statusColor(data.status) == 'yellow' ? statusColor(data.status) : 'gray'" style="float: left; cursor: pointer; margin-left: 5px;" @click.stop="changeStatus(data, 'CAUTION')">주의</div>
											<div class="status" :class="statusColor(data.status) == 'red' ? statusColor(data.status) : 'gray'" style="float: left; cursor: pointer; margin-left: 5px;" @click.stop="changeStatus(data, 'EMERGENCY')">경고</div>
										</td>
										<th>조치 여부</th>
										<td>{{ getActionStatusType(data.actionStatus) }}</td>
									</tr>
									<tr>
										<th>오늘 이상 횟수</th>
										<td>
										</td>
										<th>
											총 이상 횟수
										</th>
										<td>
										</td>
									</tr>
									<tr>
										<th>측정 일시</th>
										<td>
											{{ data.recordDetailDate.substring(0, 19) }}
										</td>
										<th>
											수신 일시
										</th>
										<td>
											{{ data.updateDate.substring(0, 19) }}
										</td>
									</tr>
								</tbody>
							</table>
						</template>
					</div>
				</div>
				<div class="center dialog-flex">
					<div>
						<span class="dialog-tag">응급 조치 기록</span>
						<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
							<colgroup>
								<col width="140px" />
								<col width="500px" />
								<col width="140px" />
								<col width="460px" />
							</colgroup>
							<tbody>
								<tr style="border-top: 1px solid #191C26">
									<th>분류</th>
									<td>
										{{ getRecordType(selectRecordType) }}
									</td>
									<!-- <th>
										총 이상 횟수
									</th>
									<td>
										<input class="input-crud" type="text" maxlength="2" v-model="item.emergencyDate" required>
									</td> -->
								</tr>
								<tr>
									<th>상세 내용</th>
									<td colspan="4">
										<textarea class="textarea-crud" v-model="item.emergencyContents" required></textarea>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px;">
					<button type="button" class="btn-save fright" title="Save" @click.stop="managerCheck()">
						저장
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						닫기
					</button>
				</div>
			</form>
		</div>
		<DataHistory v-if="isOpenHistory" :selectData="collectData" />
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";
import DataHistory from "@/components/collectData/DataHistory.vue";
export default {
	name: "CollectDataPopup",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
		this.selectRecordType = this.collectData.dataList[0].recordType;
	},
	data() {
		return {
			item: {
				emergencyDate: "",
				emergencyContents: ""
			},
			selectRecordType: "",
			isOpenHistory: false,
		};
	},
	props: {
		collectData: {
			type: Object,
			required: true
		}
	},
	components:{
		DataHistory
	},
	methods: {
		managerCheck(){
			this.logger.debug(this, "managerCheck()");

			var recordId = "";

			for(var i = 0; i < this.collectData.dataList.length; i++){
				if(this.collectData.dataList[i].recordType == this.selectRecordType){

					recordId = this.collectData.dataList[i].id;
				}
			}

			this.$set(this.item, 'recordId', recordId);
			this.$set(this.item, 'recordType', this.selectRecordType);
			this.$set(this.item, "userId", sessionStorage.getItem('userId'));
			axios
				.post(this.config.contextRoot + "/collectData/managerCheck.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						if(response.data.count == 0){
							this.$confirm("담당자가 이닙니다 배정 받으시겠습니까?", "Question", "question").then(() => {
								this.insertManager();
							});
						}
						else{
							this.doValidation();
						}
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doOpen() {
			this.logger.debug(this, "doOpen()");
			this.isOpenHistory = true;
		},
		insertManager(){
			this.logger.debug(this, "insertManager()");

			this.$set(this.collectData, "userId", sessionStorage.getItem('userId'));
			axios
				.post(this.config.contextRoot + "/home/insertManager.do", this.collectData)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("완료되었습니다.", "Success", "success").then(() => {
							// location.reload();
							this.doValidation();
							// location.reload();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("응급 조치 기록을 등록 하시겠습니까?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");

			axios
				.post(this.config.contextRoot + "/field/selectSortOrder.do", this.item)
				.then((response) => {
					console.log(response);

					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");

			var recordId = "";

			for(var i = 0; i < this.collectData.dataList.length; i++){
				if(this.collectData.dataList[i].recordType == this.selectRecordType){

					recordId = this.collectData.dataList[i].id;
				}
			}

			this.$set(this.item, 'recordId', recordId);
			this.$set(this.item, 'recordType', this.selectRecordType);
			this.$set(this.item, "userId", sessionStorage.getItem('userId'));

			axios
				.post(this.config.contextRoot + "/collectData/insertEmergency.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						this.$alert("Complete", "Success", "success").then(() => {
							this.doClose();
							location.reload();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		changeStatus(data, status){
			this.logger.debug(this, "changeStatus()");

			this.$set(data, 'changeStatus', status);

			this.$confirm("변경하시겠습니까?", "Question", "question").then(() => {
				axios
				.post(this.config.contextRoot + "/collectData/changeStatus.do", data)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("변경하였습니다.", "Success", "success").then(() => {
							// location.reload();
							data.status = status;
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
			});

		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.CollectDataPopup.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.CollectDataPopup.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isCollectDataPopup");
				this.$parent.isCollectDataPopup = false;
			}.bind(this), 410);
		},
		selectRecord(recordType){
			this.selectRecordType = recordType;
		},
		getRecordType(recordType){
			var result = "";

			if(recordType == 'WEIGHT'){
				result = '체중'
			}
			if(recordType == 'BLOOD_PRESSURE'){
				result = '혈압'
			}
			if(recordType == 'BLOOD_GLUCOSE'){
				result = '혈당'
			}
			if(recordType == 'HEART_RATE'){
				result = '심박수'
			}
			if(recordType == 'STEP_COUNT'){
				result = '걸음수'
			}
			if(recordType == 'CALORIE'){
				result = '칼로리'
			}
			if(recordType == 'PROTEINURIA'){
				result = '단백뇨'
			}
			if(recordType == 'OXYGEN_SATURATION'){
				result = '산소포화도'
			}
			if(recordType == 'STRESS'){
				result = '스트레스'
			}
			if(recordType == 'SLEEP_TIME'){
				result = '수면시간'
			}

			return result;
		},
		getStatusType(status){
			var result = "정상";
			if(status == 'EMERGENCY'){
				result = '경고'
			}
			if(status == 'CAUTION'){
				result = '주의'
			}
			return result;
		},
		getActionStatusType(status){
			var result = "조치 전";
			if(status == 'ACTION'){
				result = '조치 전'
			}
			if(status == 'COMPLETE'){
				result = '조치 완료'
			}
			return result;
		},
		statusColor(status){
			var result = "green";
			if(status == 'EMERGENCY'){
				result = 'red'
			}
			if(status == 'CAUTION'){
				result = 'yellow'
			}
			return result;
		},
		getSleepTime(ms){
			var hour = String(Math.floor((ms / (1000*60*60)) % 24)).padStart(2, "0");
			var min = String(Math.floor((ms / (1000*60)) % 60)).padStart(2, "0");
			var sec = String(Math.floor((ms / (1000)) % 60)).padStart(2, "0");
			return hour+':'+min+':'+sec;
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.btn-collect{
	min-width: 80px;
	background-color: #EBF4FF;
	border: none;
	color: #000000;
}
.btn-collect:first-child{
	margin-left: 25px;
}
.btn-collect:hover{
	color: #fff;
	background-color: #0176F9;
}
.data-on{
	color: #fff;
	background-color: #0176F9;
}
.proteinuria_div{
	display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 15px;
    font-size: 16px;
    font-weight: bold;
}
.proteinuria_color{
	width: 40px;
	height: 40px;
}
.proteinuria_set{
	width: 48px; height: 48px; border: 4px solid #2A2A2A; border-radius: 4px;
}
.gray{
	background-color: #979ea5;
}
</style>
